export const SIP_PLANS_API_RETRY_COUNT = 1
export const SIP_SUMMARY_QUERY_KEY = 'sip-summary'

type SipQueryStatus = {
  isLoading: boolean
  isError: boolean
  isFetching: boolean
}

export function isSipQueryLoading(query: SipQueryStatus): boolean {
  return query.isLoading || (query.isError && query.isFetching)
}

export function isSipQueryFetchFailed(query: SipQueryStatus): boolean {
  return query.isError && !query.isFetching
}
